import React, {useEffect, useState} from 'react';
import {Container, Row, Col, Card, CardBody} from 'reactstrap';
import {Link} from 'react-router-dom';

//swiper
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import {Pagination, Autoplay, Navigation} from "swiper";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../config';
import {useWindowSize} from "../../hooks/useWindowSize";

const Clients = () => {
    const {t} = useTranslation();
    const {width} = useWindowSize();

    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {
        fetch(`${appConfig.baseUrl}/read-organization-photos`, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "login": 'HRplus+',
                "password": 'Ctc0oTYayc77z',
            },
        })
            .then(resp => resp.json())
            .then(resp => {
                setOrganizations(resp);
            })
            .catch(err => console.log(err))

    }, []);

    return (
        <React.Fragment>
            <section className="section bg-light" id="categories">
                <Container fluid>
                    <Row className="justify-content-center">
                        <Col lg={5}>
                            <div className="text-center mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">{t('t-clients-head').replace('{appName}', appConfig.appName)}</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="m-auto col-sm-9 col-12">
                            <Swiper modules={[Navigation, Autoplay, Pagination]}
                                    slidesPerView={3}
                                    spaceBetween={20}
                                    navigation={{
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    }}
                                    pagination={{
                                        el: ".swiper-pagination",
                                        clickable: true,
                                    }}
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 2,
                                            spaceBetween: 20,
                                        },
                                        768: {
                                            slidesPerView: 3,
                                            spaceBetween: 24,
                                        },
                                        1024: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    loop={true}
                                    autoplay={{
                                        delay: 2000,
                                        disableOnInteraction: false,
                                        pauseOnMouseEnter: true,
                                    }}
                                    className="mySwiper swiper mySwiper pb-4"
                            >
                                <div className="swiper-wrapper">
                                    {organizations.map(organization => <SwiperSlide key={organization['id']}>
                                        <Card>
                                            <CardBody className={"h-100"}>
                                                <div className={"d-flex justify-content-center align-items-center"}
                                                     style={{minHeight: width > 1024 ? 300 : 200}}>
                                                    <img
                                                        src={appConfig.baseUrl.concat('/', organization['photo'].replace("https://hrplus.uz/", ''))}
                                                        alt={organization.name}
                                                        className="img-fluid rounded mb-3 w-auto"
                                                    />
                                                </div>

                                                <h5 className={'mb-0'}>
                                                    {organization.name}
                                                </h5>
                                                {/*<Link to="#" className="float-end "> {t('t-view')} <i*/}
                                                {/*    className="ri-arrow-right-line align-bottom"></i></Link>*/}
                                            </CardBody>
                                        </Card>
                                    </SwiperSlide>)}
                                </div>
                                <div className="swiper-pagination swiper-pagination-dark"></div>
                            </Swiper>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Clients;